import React, { createContext, useRef, useState } from 'react'
import Dialog from '../'
import { IDialogProps } from '../Dialog'

export type IDialogContextValue = [(props: IDialogProps) => void, () => void]

export const DialogContext = createContext(null)

const DialogProvider = ({ children }) => {
  const timeoutRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [dialogProps, setDialogProps] = useState<Partial<IDialogProps>>({})

  const closeDialog = () => {
    setIsOpen(false)

    timeoutRef.current = setTimeout(() => setDialogProps({}), 300)
  }

  const onClose = async () => {
    await dialogProps?.onClose?.()

    closeDialog()
  }

  const callDialog = (props: IDialogProps) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)

      timeoutRef.current = null
    }

    setDialogProps(props)
    setIsOpen(true)
  }

  const contextValue = useRef([callDialog, closeDialog])

  return (
    <DialogContext.Provider value={contextValue.current}>
      {children}
      <Dialog {...dialogProps} isOpen={isOpen} onClose={onClose} />
    </DialogContext.Provider>
  )
}

export default DialogProvider
